const html = require('choo/html')

module.exports = function GameScreen (args) {
  const {
    children = null,
    onClick = null,
    onMouseUp = null,
    onMouseDown = null,
    onMouseOver = null,
    onMouseMove = null,
    onMouseLeave = null,
    onMouseEnter = null,
    disabled = false,
    fullscreen = false,
    paused = false,
    sharingMode = false
  } = args
  const fullscreenClass = fullscreen ? 'fullscreen' : ''
  return html`
    <div
      id="gamescreen" 
      class="gamescreen ${fullscreenClass} ${disabled ? 'disabled' : ''} ${paused ? 'paused' : ''} ${sharingMode ? 'sharing-mode' : ''}"
      onclick=${onClick}
      onmousedown=${onMouseDown}
      onmouseup=${onMouseUp}
      onmousemove =${onMouseMove}
      onmouseover=${onMouseOver}
      onmouseleave=${onMouseLeave}
      onmouseenter=${onMouseEnter}>
      ${children}
    </div>
  `
}
